import Picker from "pickerjs";
import 'pickerjs/dist/picker.css';

const main = () => {
    const datePickers = document.querySelectorAll('.c-date-picker input[type="text"]');
    if (datePickers.length === 0) return;

    datePickers.forEach(pickerObj => {
        const picker = new Picker(pickerObj, {
            language: 'ja-JP',
            format: 'YYYY/MM/DD',
            inline: false,   // カレンダーをインライン表示するかどうか
            autoHide: true,  // 選択後に自動で閉じる
            text: {
                title: '年月日を選択',
                cancel: 'キャンセル',
                confirm: '決定',
            },
        });

        // ホイール感度を調整するためのカスタムイベントハンドラー
        let wheelDelta = 0;
        const wheelThreshold = 60; // ホイールの閾値（大きくするほど鈍感になる）

        // 元のwheelイベントリスナーを削除して、カスタムのものに置き換え
        const gridElement = picker.picker.querySelector('.picker-grid');
        if (gridElement) {
            // 元のwheelイベントを無効化
            gridElement.addEventListener('wheel', (event) => {
                event.stopImmediatePropagation();
                event.preventDefault();

                let { target } = event;

                if (target === gridElement) {
                    return;
                }

                // デルタ値を累積
                wheelDelta += Math.abs(event.deltaY);

                // 閾値を超えた場合のみアクションを実行
                if (wheelDelta >= wheelThreshold) {
                    while (target.parentElement && target.parentElement !== gridElement) {
                        target = target.parentElement;
                    }

                    const type = target.getAttribute('data-type');

                    if (event.deltaY < 0) {
                        picker.prev(type);
                    } else {
                        picker.next(type);
                    }

                    // デルタ値をリセット
                    wheelDelta = 0;
                }
            }, { capture: true });
        }
    });
}

export default main;